import { render } from "./EditUpdate.vue?vue&type=template&id=7561e4ae"
import script from "./EditUpdate.vue?vue&type=script&lang=js"
export * from "./EditUpdate.vue?vue&type=script&lang=js"
script.render = render

export default script